export enum PaymentMethod {
  /** A transfer to the payee's saved bank account. */
  TRANSFER = 'TRANSFER',
}
